interface Props {
  error: string;
}

export function BusinessOrderStartError({error}: Props) {
  switch (error) {
    case 'database.error':
      return <div>
        Änderungen zum starten des BAs konnten nicht gespeichert werden. Bitte versuchen Sie es erneut.
      </div>;
    case 'not.found.business.order':
      return <div>
        BA konnte nicht gefunden werden. Möglicher weise wurde er storniert oder ist bereits gestartet.
      </div>;
    case 'already.started.business.order':
      return <div>
        BA konnte nicht gefunden werden. Möglicher weise wurde er storniert oder ist bereits gestartet.
      </div>;
    case 'not.found.business.order.reproduction.reason':
      return <div>
        BA konnte nicht gefunden werden. Möglicher weise wurde er storniert oder ist bereits gestartet.
      </div>;
    case 'not.ready.business.order':
      return <div>
        BA konnte nicht gefunden werden. Möglicher weise wurde er storniert oder ist bereits gestartet.
      </div>;
    case 'film.inventory.is.full':
      return <div>
        Film Lager ist voll.
      </div>;
    case 'film.inventory.is.missing':
      return <div>
        Film Lager des Haupt BAs konnte nicht gefunden werden.
      </div>;
    case 'deleted.business.order':
      return <div>
        Der ausgewählte BA wurde storniert.
      </div>;
    case 'not.found.article':
      return <div>
        Artikel zum BA konnte nicht gefunden werden.
      </div>;
    case 'not.found.article.change.detection':
      return <div>
        Änderungen an der Fertigungsliste zum BA konnten nicht gefunden werden.
      </div>;
    case 'deleted.article':
      return <div>
        Artikel zum BA wurde gelöscht.
      </div>;
    case 'locked.article':
      return <div>
        Artikel zum BA wurde gesperrt.
      </div>;
    case 'not.valid.article.change.detection':
      return <div>
        Bitte überprüfen Sie die Artikeldaten und geben Sie die Fertigungsliste frei.
      </div>;
    case 'not.found.article.history':
      return <div>
        Bitte überprüfen Sie die Artikeldaten und geben Sie die Fertigungsliste frei.
      </div>;
    case 'not.found.article.data.utilize.sum':
      return <div>
        Bitte überprüfen Sie die das Format in den Artikeldaten.
      </div>;
    case 'not.found.article.production.list':
      return <div>
        Bitte überprüfen Sie die Fertigungsliste.
      </div>;
    case 'incorrect.material':
      return <div>
        Material Zuordnungsfehler. Bitte die Artikeldaten prüfen oder Material manuell auswählen.
      </div>;
    case 'incorrect.material.base':
      return <div>
        Konnte kein Basismaterial zuordnen.
      </div>;
    case 'incorrect.material.cu-foil':
      return <div>
        Konnte kein Cu-Folien Material zuordnen.
      </div>;
    case 'incorrect.material.prepreg':
      return <div>
        Konnte kein Prepreg Material zuordnen.
      </div>;
    case 'material.not.sufficient':
      return <div>
        Material Zuordnungsfehler. Bitte Materialverfügbarkeit der Cu-Folie prüfen.
      </div>;
    case 'incorrect.target.material':
      return <div>
        Material Zuordnungsfehler. Zielmaterial konnte nicht gesetzt werden.
      </div>;
    case 'price.requires.validation.zero':
      return <div>
        Preis in Abruf ist 0,00€. Bitte Vorgang zur Preisprüfung melden.
      </div>;
    case 'price.requires.validation.old':
      return <div>
        Abruf Preis Gültigkeitsdauer ist vorbei. Bitte Vorgang zur Preisprüfung melden.
      </div>;
    case 'price.requires.validation.price.increase':
      return <div>
        Kunde hat seit Erstellung des Abrufs eine Preiserhöhung erhalten. Bitte Vorgang zur Preisprüfung melden.
      </div>;
    case 'price.requires.validation.article.changed':
      return <div>
        Artikel wurde geändert. Bitte Vorgang zur Preisprüfung melden.
      </div>;
    default:
      return <div>
        Unbekannter Fehler. Bitte Artikeldaten prüfen.
      </div>;
  }
}
